





















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Job } from '@/models/jobDetail/job';
import { JobNotification } from '@/models/jobNotification/jobNotification';
import { JobNotificationAttachment } from '@/models/jobNotification/jobNotificationAttachment';
import { v4 as uuidv4 } from 'uuid';
import imageCompression from 'browser-image-compression';
import Nullable from '@/types/nullable';
import * as JobsAPI from '@/api/jobsApi';
import * as S3API from '@/api/s3Api';
import { vxm } from '@/stores';

interface HTMLInputEvent extends Event {
  target: HTMLInputElement & EventTarget;  
}

@Component({})
export default class TestFailedNotification extends Vue {
  @Prop({ type: Object, default: null }) public job: Nullable<Job>;  
  private loading: boolean = false;
  private processingPhoto: boolean = false;
  private errorMessage: string = null;
  private editValid: boolean = true;
  private jobNotification: JobNotification = this.init();
  private uploadingPhoto: boolean = false;
  private confirmDialog: boolean = false;
  $refs: {
    newPhotoImage: HTMLFormElement;
    editForm: HTMLFormElement;
  }

  required (value: string): boolean | string {
    return (!!value && value.trim().length > 0) || "Required";
  }

  max64characters (value: string): boolean | string {
    return (!value || (value && value.trim().length <= 64)) || "Maximum 64 Characters";
  }
  max100characters (value: string): boolean | string {
    return (!value || (value && value.trim().length <= 100)) || "Maximum 100 Characters";
  }

  max2000characters (value: string): boolean | string {
    return (!value || (value && value.trim().length <= 2000)) || "Maximum 2000 Characters";
  }

  validEmail (value: string): boolean | string { 
    return /.+@.+/.test(value) || "Must be a valid email address";
  }

  get noPhotos(): boolean {
    return this.jobNotification.attachments.length == 0;
  }

  async add(){
    this.$refs.newPhotoImage.click();
  }

  async remove(attachment: JobNotificationAttachment) {
    this.jobNotification.attachments.splice(this.jobNotification.attachments.indexOf(attachment), 1);
  }

  async getFileData(event: HTMLInputEvent): Promise<File> {
    this.processingPhoto = true;
    
    let file = null;
    const files = event.target.files;

    if(files[0] !== undefined) {
      const options = { 
        maxSizeMB: 1
      }

      file = await imageCompression(files[0], options);
    }

    this.processingPhoto = false;

    return file;
  }

  async handleNewPhotoCreation(event: HTMLInputEvent) {
    this.uploadingPhoto = true;
    let attachmentID = uuidv4();    

    let photo = await this.getFileData(event);
    let photoUri = await imageCompression.getDataUrlFromFile(photo);
    let uploadUri = await JobsAPI.getJobNotificationAttachmentUploadURL(this.$route.params.jobID, this.jobNotification.id, attachmentID, photo.type, photo.name);
    let decodedUri = decodeURIComponent(uploadUri);
    let attachmentUri = decodedUri.substring(decodedUri.indexOf('job/'), decodedUri.indexOf('?'));
    
    this.jobNotification.attachments.push({
      id: uuidv4(),
      jobNotificationID: this.jobNotification.id,
      attachmentUri: attachmentUri,
      attachmentName: photo.name,
      localUri: photoUri,
      uploadUri: uploadUri
    });
    this.uploadingPhoto = false;
  }

  init(): JobNotification {
    return { 
      id: uuidv4(),
      jobID: this.job.id,
      client: this.job.client.name,
      contactName: this.job.client.location.contactName,
      contactEmail: this.job.client.location.contactEmail,
      location: this.clientLocation(this.job),
      locationOnSite: null,
      tagNumber: null,
      detail: null,
      createdBy: vxm.user.displayName,
      attachments: []
    }
  }

  clientLocation(job: Job): string {
    return `${job.client.location.siteName || ''}, ${job.client.location.name || ''}, ${job.client.location.address.street || ''}, ${job.client.location.address.suburb || ''}, ${job.client.location.address.state || ''}`.replace(',,', ',').replace(/(^,)|(,$)/g, "");
  }

  cancel(confirm: boolean){  
    if(!confirm) {
      this.confirmDialog = true;
    } else {
      this.confirmDialog = false;

      this.$emit('cancel');

      this.jobNotification = this.init();
      this.errorMessage = null;
      this.$refs.editForm.reset();
    }
  }

  async save(){
    this.loading = true;

    try {
      // First upload any attachments
      this.jobNotification.attachments.forEach(async (attachment) => {
        let file = await imageCompression.getFilefromDataUrl(attachment.localUri);
        await S3API.upload(attachment.uploadUri, file);
      });

      // Create and Send notification
      console.log(this.jobNotification)
      await JobsAPI.sendFailedTestNotification(this.jobNotification);      

      this.$emit('save');
      this.jobNotification = this.init();
      this.$refs.editForm.reset();

      vxm.navigation.showSnackbar({
        message: 'Notification Sent', 
        timeout: 3000,
        color: 'success'
      });

    } catch(err){
      this.errorMessage = err;
    }

    this.loading = false;
  }
}

